import { render } from "./Quotes.vue?vue&type=template&id=b885b4d0&scoped=true"
import script from "./Quotes.vue?vue&type=script&lang=js"
export * from "./Quotes.vue?vue&type=script&lang=js"

import "./Quotes.vue?vue&type=style&index=0&id=b885b4d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b885b4d0"]])

export default __exports__